import DropDownMultiSelector from "./dropDownMultiSelector";

export default DropDownMultiSelector;